import axios from "@/lib/axios";

export type AuditByQuizIdRequestParams = {
  companyId: string;
  quizId: string;
};

export type AuditByQuizIdReponse = {
  id: string;
  company: {
    id: string;
    name: string;
    size: string;
    sectorName: string;
    subsectorName: string;
  };
  evaluator: {
    id: string;
    name: string;
  };
  status: "TO_CONFIRM" | "TO_SCHEDULE" | "SCHEDULED" | "AUDITED";
  scheduledDate: string;
  scheduledTime: {
    hour: number;
    minute: number;
    second: number;
    nano: number;
  };
  quizId: string;
};

export const getAuditByQuizId = (params: AuditByQuizIdRequestParams) =>
  axios
    .get<AuditByQuizIdReponse>(
      `/v1/companies/${params.companyId}/quizzes/${params.quizId}/audit`,
    )
    .then((res) => res.data);
